module.exports = __webpack_public_path__ + "img/weber_metallbearbeitung_velbert_firma_front.d4239c12.jpg";